import React from 'react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import './assets/robotofonts.css';
import './App.scss';
import Home from './containers/Home';
import Photos from './containers/Photos';
import SignUp from './containers/SignUp';
import RegistrationPage from './containers/Registration';
import WompiResponsePage from './containers/WompiResponse';

const App = () => {
  return (
    <Router>
      <div className='App'>
        <Switch>
          <Route exact path='/' component={Home} />
          <Redirect exact from='/ranking' to='/' />
          <Redirect exact from='/login' to='/' />
          <Redirect exact from='/welcome' to='/' />
          <Redirect exact from='/edit' to='/' />
          <Route path='/photos' component={Photos} />
          <Route path='/registration' component={RegistrationPage} />
          <Route path='/payment-success' component={WompiResponsePage} />
          <Route path='/sign-up' component={SignUp} />
          <Redirect from='*' to='/' />
        </Switch>
      </div>
    </Router>
  );
};

export default App;
